<mat-card class="custom-card">
  <mat-card-header>
      <mat-card-title>Edit Note</mat-card-title>
  </mat-card-header>

  <mat-card-content class="padding lrg all">
    <!-- Edit Note Form -->
    <form [formGroup]="confirmForm" autocompete="off" (keyup.enter)="confirmSelected()">
      <div class="section margin top lg">
        <!-- Note -->
        <div class="row">
          <mat-form-field floatLabel="always" appearance="outline" class="full-width">
            <textarea
              matInput 
              class="notes-area"
              id="reason"
              maxlength="2000"
              placeholder="Enter note"
              formControlName="reason"
              (focus)="focusOn('reason')"
              (focusout)="focusOn('reason')"
              autocomplete="off"
              cdkFocusInitial
              aria-describedby="Reason for action"
              rows="5"
            >
            </textarea>
            <div class="row flex-end">
              <mat-hint>{{ confirmForm.controls.reason.value?.length || 0 }} / 2000</mat-hint>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.reason">
              <div
                class="caption error-message"
                *ngIf="fieldHasErrorMessages(confirmForm, validation, 'reason')"
                id="reasonErrors"
              >
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-actions>
    <div class="row flex-end">
      <button mat-stroked-button id="btn-cancel" class="margin lrg top bottom left"(click)="cancelSelected()">
        Cancel
      </button>

      <button
        mat-flat-button
        id="btn-confirm"
        class="margin lrg top bottom left"
        (click)="confirmSelected()"
        [disabled]="!confirmForm.valid && data.reasonRequired"
      >
        Update
      </button>
    </div>
  </mat-card-actions>
</mat-card>

